import { useToastStore, ToastType } from '@/store/toastStore'

interface ToastParams {
  type: ToastType
  text: string
  duration?: number
  onClick?: () => void
  /** 뒤이은 토스트에 밀려 2초로 단축되지 않는다. 자세한 조건은 `Toast.sticky` 참조. */
  sticky?: boolean
}

export const toast = ({ type, text, duration = 5000, onClick, sticky }: ToastParams) => {
  const { addToast } = useToastStore.getState()
  addToast({ type, text, duration, onClick, sticky })
}

export const useToast = () => {
  const { addToast, removeToast, clearAllToasts } = useToastStore()

  return {
    toast: ({ type, text, duration = 5000 }: ToastParams) => {
      addToast({ type, text, duration })
    },
    removeToast,
    clearAllToasts,
  }
}
